// Tiny WebAudio "ping" used for in-app notifications.
// Generates two short, soft sine tones without loading any audio file.
let audioCtx = null;

function getCtx() {
  if (audioCtx) return audioCtx;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioCtx = new Ctx();
    return audioCtx;
  } catch (_e) {
    return null;
  }
}

export function playNotificationPing() {
  // Respect user preference: skip if explicitly muted
  try {
    if (typeof localStorage !== 'undefined' && localStorage.getItem('notif_sound_muted') === '1') return;
  } catch (_e) { /* ignore */ }
  const ctx = getCtx();
  if (!ctx) return;
  // Resume context if suspended (autoplay policies)
  if (ctx.state === 'suspended') {
    try { ctx.resume(); } catch (_e) { /* ignore */ }
  }
  const now = ctx.currentTime;
  const masterGain = ctx.createGain();
  masterGain.gain.setValueAtTime(0.0001, now);
  masterGain.gain.exponentialRampToValueAtTime(0.18, now + 0.02);
  masterGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.35);
  masterGain.connect(ctx.destination);

  const tone = (freq, start, dur) => {
    const o = ctx.createOscillator();
    o.type = 'sine';
    o.frequency.setValueAtTime(freq, now + start);
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, now + start);
    g.gain.exponentialRampToValueAtTime(0.4, now + start + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
    o.connect(g);
    g.connect(masterGain);
    o.start(now + start);
    o.stop(now + start + dur + 0.05);
  };

  // Two-tone pleasant chime: high, then slightly higher
  tone(880, 0, 0.12);
  tone(1320, 0.08, 0.18);
}
